/* eslint-disable quotes */
import type { Color, ColorContrast, ColorMeteor, ColorSchema, Theme } from "themes/interfaces";
import { BaseBorder, BaseColor, BaseComponent, BaseFont, BaseSpacing } from "themes/base";
import { Enums } from "utils";

export const Light: Theme = {
  id: Enums.EnumTheme.Light,
  font: BaseFont,
  color: {
    ...BaseColor,
    theme: { color: "#e7e7f1", accent: "#d9d9e3", text: "#191b22" } as ColorSchema,
    border: { color: "#c4c6d3", accent: "#747782" } as ColorContrast,
    shadow: { color: "2px 2px 0px 0px #c4c6d3", accent: "4px 4px 0px 0px #191b22" } as ColorContrast,
    input: { color: "#ffffff", accent: "#c4c6d3" } as ColorSchema,
    font: { color: "#191b22", accent: "#434651" } as ColorContrast,
    background: { color: "#faf8ff", accent: "#ffffff", textAccent: "#434651" } as ColorSchema,
    primary: { color: "#3559a8", accent: "#5072c2", text: "#ffffff", textAccent: "#faf8ff" } as ColorSchema,
    accent: { color: "#3559a8", accent: "#1a4391", text: "#ffffff" } as ColorSchema,
    secondary: { color: "#ffdad3", accent: "#fe9c88", text: "#954838" } as ColorSchema,
    disabled: { color: "#ededf7", text: "#747782" } as ColorSchema,
    meteor: {
      head: "#ff9f43",
      glow: "rgba(255, 140, 50, 0.8)",
      tail: "linear-gradient(to left, rgba(255,140,50,0.85), rgba(255,200,60,0.2) 20%, transparent 100%)",
    } as ColorMeteor,
  } as Color,
  border: BaseBorder,
  spacing: BaseSpacing,
  component: BaseComponent,
};
